import { numberWithCommas } from './sliderFunctions';

const QOE_PRICE_CAP = 45000;
const QOE_LITE_PRICE_CAP = 34000;
const roundToNearest100 = (price) => Math.round((price + 0.000001) / 100) * 100;

export const calculateQoEPrice = (price) => {
  const pricingEV = Math.max(price, 1000000);
  const basePrice =
    pricingEV <= 5000000
      ? 16500 + (pricingEV - 1000000) * 0.0025
      : 26500 + (pricingEV - 5000000) * 0.000925;
  // Cap at $45K
  return Math.min(basePrice, QOE_PRICE_CAP);
};

export const calculateQoELitePrice = (price) => {
  const basePrice = calculateQoEPrice(price) * 0.68;
  // Cap at $34K
  return Math.min(basePrice, QOE_LITE_PRICE_CAP);
};

// Apply expedite fees based on timeline
export const applyExpediteFee = (basePrice, timeline) => {
  if (timeline === '3-4 weeks' || timeline === '4+ weeks') {
    return basePrice; // No expedite fee
  } else if (timeline === '2 weeks') {
    return basePrice * 1.1; // 10% expedite fee
  } else if (timeline === '1 week') {
    return basePrice * 1.15; // 15% expedite fee
  }
  return basePrice;
};

// Format price with rounding and k notation (e.g., $10.5k)
export const formatPrice = (price) => {
  const roundedPrice = roundToNearest100(price);

  // Keep prices under $1000 in regular format
  if (roundedPrice < 1000) {
    return `$${numberWithCommas(roundedPrice)}`;
  }

  // Convert to k format for $1000+
  const kValue = roundedPrice / 1000;
  // If it's a whole number, don't show decimals
  if (kValue % 1 === 0) {
    return `$${kValue}k`;
  }
  // Otherwise show one decimal place
  return `$${kValue.toFixed(1)}k`;
};

// Calculate and format QoE price
export const getFormattedQoEPrice = (price, timeline) => {
  const basePrice = calculateQoEPrice(price);
  const finalPrice = applyExpediteFee(basePrice, timeline);
  return formatPrice(finalPrice);
};

// Calculate and format QoE Lite price
export const getFormattedQoELitePrice = (price, timeline) => {
  const basePrice = calculateQoELitePrice(price);
  const finalPrice = applyExpediteFee(basePrice, timeline);
  return formatPrice(finalPrice);
};

export const shouldShowStartingAtQoEPrice = (price) => {
  return price >= 25000000;
};

export const shouldShowStartingAtQoELitePrice = (price) => {
  return price >= 25000000;
};
